// PointsPilot logo — inline SVG so it ships in the JS bundle with no
// external file. Cannot 404 and renders crisp at any size.
//
// Brand:
//   ink  #182185  (dark navy)
//   blue #5091E9  (primary blue)
//   sky  #5993F7  (light blue)
//   cream #FFF3F8 (off-white)

export default function Logo({ className = '', height = 36, withWordmark = true, title = 'PointsPilot' }) {
  // Two layout modes: mark-only (square viewBox) or mark + wordmark (wide viewBox)
  if (!withWordmark) {
    return (
      <svg
        viewBox="0 0 120 120"
        height={height}
        width={height}
        className={className}
        role="img"
        aria-label={title}
      >
        <LogoMark />
      </svg>
    );
  }
  return (
    <svg
      viewBox="0 0 640 140"
      height={height}
      className={className}
      role="img"
      aria-label={title}
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0,10)">
        <LogoMark />
      </g>
      <text
        x="150"
        y="92"
        fontFamily='"Plus Jakarta Sans", Inter, system-ui, sans-serif'
        fontWeight="800"
        fontSize="74"
        letterSpacing="0"
      >
        <tspan fill="#182185">points</tspan>
        <tspan fill="#5091E9">pilot</tspan>
      </text>
    </svg>
  );
}

function LogoMark() {
  // 120x120 mark: gradient blue disc, dark crescent, white airplane swooping
  // up-right, small dark plane outside top-right for motion.
  return (
    <g>
      <defs>
        <linearGradient id="pp-disc" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#5993F7" />
          <stop offset="100%" stopColor="#5091E9" />
        </linearGradient>
      </defs>
      {/* Light blue disc */}
      <circle cx="60" cy="60" r="52" fill="url(#pp-disc)" />
      {/* Dark navy crescent (lower-right slice) */}
      <path
        d="M60 112
           a52 52 0 0 0 45 -78
           a40 40 0 0 1 -45 78
           z"
        fill="#182185"
      />
      {/* White airplane sweeping up to the right */}
      <path
        d="M22 78
           L78 38
           L72 52
           L96 50
           L70 64
           L74 80
           L60 70
           L40 88
           L48 70
           Z"
        fill="#FFFFFF"
      />
      {/* Small dark plane outside top-right for motion */}
      <path
        d="M100 18
           l14 -2
           l-10 6
           l4 2
           l-8 2
           l-2 -4
           l-4 2
           z"
        fill="#182185"
      />
    </g>
  );
}
